import gql from 'graphql-tag';

export const ExperimentalResetCollabService = gql`
	mutation ExperimentalResetCollabService($contentId: String!, $behind: String!) @experimental {
		experimentalResetCollabService(contentId: $contentId, behind: $behind) {
			traceId
		}
	}
`;
